import { render, staticRenderFns } from "./RiskAnalysisReview.vue?vue&type=template&id=23fb9249&"
import script from "./RiskAnalysisReview.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports